import React from 'react'
import { faSignIn } from '@fortawesome/pro-solid-svg-icons'
import Link from 'next/link'
import { faCompass } from '@fortawesome/pro-duotone-svg-icons'
import language from 'services/Language'
import { Collective } from 'graphql/generated'
import { ROOT_HOSTNAME } from 'lib/helpers'
import Button from 'components/Button'
import Image from 'next/image'

interface IProps {
  collective: Pick<NonNullable<Collective>, 'name'>
}

function CollectiveClosedNotice({ collective }: IProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-1 items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <Image
              className="mx-auto mt-3 h-8 w-auto"
              src="/static/new-logo-dark-horizontal@2x.png"
              alt="Upstream"
              fill
              sizes="25vw"
            />
            <h2 className="mt-6 text-center text-xl font-medium text-gray-900">
              {`Sign Up \u00b7 ${collective.name}`}
            </h2>
          </div>

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
              <p className="pb-3">{`This DAO is not accepting new members at this time.`}</p>

              <p className="pb-10 text-gray-600 font-light">{`Find other DAOs, Communities, or Events to sign up to Upstream.`}</p>

              <Link href={`${ROOT_HOSTNAME}/discover`} passHref>
                <Button
                  label="Discover"
                  color="blue"
                  fullWidth
                  className="py-3"
                  size="lg"
                  icon={faCompass}
                  iconPlacement="before"
                />
              </Link>
            </div>
          </div>

          <div className="text-center mt-2">
            <Link href="/auth/login">
              <Button
                label={language.common.loginInstead}
                icon={faSignIn}
                iconPlacement="after"
                color="textOnly"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CollectiveClosedNotice
